// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Badge_badge__1Eibr {\n  top: 10px;\n  right: 10px;\n  padding: 0px 4px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Wrapper/Badge.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".badge {\n  top: 10px;\n  right: 10px;\n  padding: 0px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": "Badge_badge__1Eibr"
};
export default ___CSS_LOADER_EXPORT___;
